import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Constant } from 'app/config/constants';
import { Device } from 'app/model/entity/device';
import { SimplePlaylist } from 'app/model/entity/simple/simple-playlist';
import { Subject } from 'rxjs';
import { UserRouteLogDevice } from 'app/model/user-route-log-device';

class RouteOption {
  id: String;
  isChecked: boolean;
  name: String;
}

@Component({
  selector: 'dialog-log-setting',
  templateUrl: './dialog-log-setting.component.html',
  styleUrls: ['./dialog-log-setting.component.scss']
})
export class DialogLogSettingComponent implements OnInit {
  /**
   * Constant
   */
  private readonly ERROR_TITLE = 'error';
  private readonly COMMON_ERROR = 'common-error';
  private readonly IS_CHECKED = 'isChecked';

  /**
   * list device
   */
  devices: Array<Device>;

  /**
   * list device
   */
  routes: Array<RouteOption>;

  public selectedRoutes: Array<RouteOption>;

  /**
   * list playlists
   */
  playlists: Array<SimplePlaylist>;

  userRouteLogDevices: UserRouteLogDevice[];

  /**
   * subject load data
   */
  loadedData: Subject<boolean> = new Subject();
  /**
   * subject reset label content
   */
  resetLabelContentSubject: Subject<string> = new Subject();
  /**
   * subject load data device
   */
  loadedDataDevice: Subject<boolean> = new Subject();
  /**
   * Subject load data playlist
   */
  loadedDataPlaylists: Subject<boolean> = new Subject();

  /**
   * subject for emit data output select box
   */
  getDataSubject: Subject<void> = new Subject();

  /**
   * list device selected
   */
  public selectedDevices: Array<Device>;

  /**
   * list playlist selected
   */
  public selectedPlaylists: Array<SimplePlaylist>;

  /**
   * Dialog title
   */
  public dialogTitle: string = 'Extraction Condition Setting';

  /**
   * OptionTypeEnum
   */
  OptionTypeEnum = OptionTypeEnum;
  Constant = Constant;

  constructor(
    public dialogRef: MatDialogRef<DialogLogSettingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.dialogTitle = this.translateService.instant(`${this.data.title}`);
    const routes = [];
    const devices = [];

    const selectedRoutes = [];
    const selectedDevices = [];

    this.data.userRouteLogDevices.forEach(userRouteLogDevice => {
      const newOption: RouteOption = {
        id: userRouteLogDevice.routeId,
        isChecked: false,
        name: userRouteLogDevice.displayName
      };
      routes.push(newOption);
      if (
        !this.data.selectedRouteIds ||
        this.data.selectedRouteIds.length === 0 ||
        this.data.selectedRouteIds.includes(userRouteLogDevice.routeId)
      ) {
        selectedRoutes.push(newOption);
        userRouteLogDevice.devices.forEach(rDevice => {
          if (!devices.find(device => device.id === rDevice.id)) {
            devices.push(rDevice);
          }
          if (
            (!this.data.selectedDeviceIds ||
              this.data.selectedDeviceIds.length === 0 ||
              this.data.selectedDeviceIds.includes(String(rDevice.id))) &&
            !selectedDevices.find(device => device.id === rDevice.id)
          ) {
            selectedDevices.push(rDevice);
          }
        });
      }
    });
    this.routes = routes;
    this.devices = devices;

    this.selectedRoutes = selectedRoutes;
    this.selectedDevices = selectedDevices;
    setTimeout(() => {
      this.loadedDataPlaylists.next();
      this.loadedDataDevice.next();
    });
  }

  /**
   * handle button enable
   */
  public enable(): void {
    this.getDataSubject.next();
    setTimeout(() => {
      this.dialogRef.close({
        selectedRouteIds: this.routes.filter(route => route.isChecked).map(route => route.id),
        selectedDeviceIds: this.devices.filter(device => device.isChecked).map(d => d.deviceId)
      });
    }, 0);
  }

  /**
   * get data condition after click enable
   * @param value
   * @param key
   */
  public getDataCondition(value: any, key: string): void {
    if (value && key === OptionTypeEnum.PLAYLIST) {
      const selectedRouteIds = this.routes.filter(route => route.isChecked).map(route => route.id);
      const devices = [];
      this.data.userRouteLogDevices.forEach(userRouteLogDevice => {
        if (selectedRouteIds.includes(userRouteLogDevice.routeId)) {
          userRouteLogDevice.devices.forEach(rDevice => {
            if (!devices.find(device => device.id === rDevice.id)) {
              rDevice.isChecked = true;
              devices.push(rDevice);
            }
          });
        }
      });
      this.devices = devices;
      this.selectedDevices = devices;
      setTimeout(() => {
        this.loadedDataDevice.next();
      });
    } else if (key === OptionTypeEnum.DEVICE) {
      const deviceActiveIds = [];
      value.forEach((device: Device) => {
        deviceActiveIds.push(device.deviceId);
      });
      const selectedDevice = [];
      this.devices.forEach(device => {
        if (deviceActiveIds.includes(device.deviceId)) {
          device.isChecked = true;
          selectedDevice.push(device);
        } else {
          device.isChecked = false;
        }
      });
      this.selectedDevices = selectedDevice;
    }
  }
}

export interface DialogData {
  userRouteLogDevices: UserRouteLogDevice[];
  title: String;
  selectedRouteIds: String[];
  selectedDeviceIds: String[];
}

export enum OptionTypeEnum {
  DEVICE = 'device',
  PLAYLIST = 'playlist',
  MEDIA_TYPE = 'mediaType'
}

export class Object {
  id: string;
  name: string;
  isChecked: boolean;
  constructor(id?: string, name?: string) {
    this.id = id;
    this.name = name;
  }
}
